<template>

    <div class="provision">
        <div class="right">
           <div class="ui-content">
               <div class="category-title">
                   <div class="title">{{detail.title}}</div>
                   <!-- <div class="tip" style="color:red;font-size:12px;flex-flow: row-reverse;font-weight:500">部分浏览器可能会无法预览，无法预览可以点击下载进行预览</div> -->
               </div>
               <div class="tip">
                   <!-- <div class="title">全部条款</div> -->
               </div>
               <div class="list"> 
                   <ul class="ui-mb20">
                        
                        <li v-for="(item,index) in files" :key="index" @click="preview(item.url,item.name)">

                            <b style="font-size:12px"><a>{{item.name}}</a></b>
                            <!-- <span>
                                <a @click="preview(item.url,item.name)"><i class="iconfont icon-chakan"></i>查看</a>
                                <a @click="download(item.url,item.name)"><i class="iconfont icon-xiazai"></i>下载</a>
                            </span> -->
                        </li>
                        

                    </ul>
               </div>
               <div class="tip" style="font-size:12px;color:red;line-height:40px;text-align:center">点击上方文件名即可预览</div>
           </div>

        </div>
        <van-dialog v-model="regPdfFlag" show-cancel-button :width="pageWidth">
            <div>
                <div style="max-height:450px;overflow-y:scroll;-webkit-overflow-scrolling: touch">
                    <div>
                        <pdf 
                            :src="regPdfFUrl"
                            :page="currentPage" 
                            @num-pages="pageCount=$event" 
                            @page-loaded="currentPage=$event"
                            @loaded="loadPdfHandler">
                        </pdf>
                    </div>
                    
                </div>
                
                <p class="arrow" style="display: flex;justify-content: space-evenly;align-items: center;height: 50px;">
                <span @click="changePdfPage(0)" class="turn" :style="{color:currentPage==1?'gray':''}">Previous</span>
                {{currentPage}} / {{pageCount}}
                <span @click="changePdfPage(1)" class="turn" :style="{color: currentPage==pageCount?'gray':''}">Next</span>
                </p>
            </div>
        </van-dialog>
    </div>
      
</template>

<script>
import storejs from "store";
import util from "@/libs/util";
import moment from 'moment';
import pdf from 'vue-pdf'
import { Dialog,Checkbox} from 'vant';
import Vue from 'vue'
Vue.use(Dialog)
export default {
  name: "provision",
  components: {
    [Dialog.name]:Dialog,
    pdf
  },
  data(){
    return{
      moment: moment,
      filename: __filename,
      publicData: storejs.get("publicData"),
      util: util,
      detail:{},
      files:[],
      regPdfFlag:false,
      regPdfFUrl:'',
      currentPage: 0, // pdf文件页码
      pageCount: 0, // pdf文件总页数
      fileType: 'pdf', // 文件类型
      pageWidth:window.innerWidth -10,
      
    }
  },
  watch: {
    
  },
  mounted() {
    this.loadDetail()
  },
  methods: {
    changePdfPage (val) {
        // console.log(val)
        if (val === 0 && this.currentPage > 1) {
          this.currentPage--
          // console.log(this.currentPage)
        }
        if (val === 1 && this.currentPage < this.pageCount) {
          this.currentPage++
          // console.log(this.currentPage)
        }
      },

    // pdf加载时
    loadPdfHandler (e) {
      this.currentPage = 1 // 加载的时候先加载第一页
    },
    async loadDetail(){
        let res = await this.$http.post("api/insuranceProduction/get", { id: this.$route.params.id });
        if(res.code == 0){
            res.t.files = JSON.parse(res.t.files)
            res.t.noticeFiles = res.t.noticeFiles?JSON.parse(res.t.noticeFiles):[]
            console.log('files',res.t.files)
            let files = []
            if(this.$route.query.type == 1){
                files = res.t.files
            }else{
                files = res.t.noticeFiles
            }
            
            let fileArr = []
            files.forEach((item,index)=>{
                let obj = {
                    name:item.name,
                    url:item.response.url
                }
                fileArr.push(obj)
            })
            this.files = fileArr
            console.log('this.files',this.files)
            this.detail = res.t
        }
    },
    preview(url, filename){
        this.regPdfFUrl = pdf.createLoadingTask(url)
        this.regPdfFlag=true
        console.log(url, filename)
        // this.getBlob(url,  (blob)=> {
        //     this.previewAS(blob, filename);
        // });
    },
    //url:文件地址 filename:想要修改为的名称
    download(url, filename) {
        this.getBlob(url,  (blob)=> {
            this.saveAs(blob, filename);
        });

    },

    getBlob(url, cb) {

        var xhr = new XMLHttpRequest();

        xhr.open('GET', url, true);

        xhr.responseType = 'blob';

        xhr.onload = function () {

        if (xhr.status === 200) {

        cb(xhr.response);

        }

        };

        xhr.send();

    },

    previewAS(blob, filename){
        if(filename.indexOf('pdf') != -1){
            blob = new Blob([blob], {
                type: 'application/pdf;chartset=UTF-8'
            })
        }else{
            blob = new Blob([blob], {
                type: 'application/word;chartset=UTF-8'
            })
        }

        var fileURL = URL.createObjectURL(blob)
        // window.open(fileURL)
        var el = document.createElement("a");
        document.body.appendChild(el);
        el.href = fileURL; //url 是你得到的连接
        el.target = '_new'; //指定在新窗口打开
        el.click();
        document.body.removeChild(el)
    },

    saveAs(blob, filename) {

        if (window.navigator.msSaveOrOpenBlob) {

        navigator.msSaveBlob(blob, filename);

        } else {

        var link = document.createElement('a');

        var body = document.querySelector('body');

        link.href = window.URL.createObjectURL(blob);

        link.download = filename;

        // fix Firefox

        link.style.display = 'none';

        body.appendChild(link);

        link.click();

        body.removeChild(link);

        window.URL.revokeObjectURL(link.href);

        };

    }
    
    
  },
}
</script>

<style lang="scss" scoped>
  .provision{
    display: flex;
    min-height: 100vh;
    .right{
      flex: 1;
      width:100%;
      .ui-content{
          width: 100%;
          background: #fff;
          margin: 0 auto;
          min-height: 100px;
          padding: 20px;
          box-sizing: border-box;
          .category-title{
            //   height: 100px;
              font-size: 0.15rem;
              color: #333;
              line-height: 50px;
              text-align: center;

          }
          .tip{
              display: flex;
              .title{
                    line-height: 50px;
                    font-size: 1em;
                    font-weight: 500;
                    color: #333;
                    text-align: center;
              }
          }
          .list{
              li{
                line-height: 1.4;
                border-bottom: 1px dashed #eee;
                list-style: none;
                display: flex;
                justify-content: space-between;
                // margin-bottom: 15px;
                padding: 15px 0;
                b{
                    a{
                        font-weight: 500;
                        font-size: 0.14rem;
                        color: #666;
                        line-height: 1;
                    }
                }
                span{
                    width: 150px;
                    display: flex;
                    justify-content: space-between;
                    color: #666;
                    a{
                        color: #666;
                        i{
                            margin-right: 4px;
                        }
                    }
                }
              }
          }
      }
      
    }
  }
</style>

<style lang="scss">
  .mine{
    .el-card__header{
      border: 0;
      font-size:14px;
      font-family:Microsoft YaHei;
      font-weight:400;
      color:rgba(51,51,51,1);
    }
    .theamColor{
      color:  #00a971;
    }
  }
</style>